/* =============================================================
   Y-BRUSH — script blog
   assets/yb-blog.js  (charger avec defer)
   1. Sommaire auto (depuis les <h2>)        [si .yb-toc présent]
   2. Barre de progression                    [si .yb-progress présent]
   3. Scrollspy                               [si sommaire présent]
   4. Carte produit auto (lien /products/…)
   5. JSON-LD FAQPage auto (depuis les <details> de l'article)
   Tout est défensif : chaque bloc s'active seulement si présent.
   ============================================================= */
(function () {
  "use strict";

  // Conteneur du corps d'article : compatible refonte + thème actuel
  var article =
    document.querySelector(".yb-article") ||
    document.querySelector(".hdt-article-content") ||
    document.querySelector(".rte") ||
    document.querySelector("article");

  function slugify(s) {
    return (s || "")
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || "section";
  }

  /* ---- 1 + 3. SOMMAIRE AUTO + SCROLLSPY ---- */
  function buildTOC() {
    var navD = document.querySelector(".yb-toc nav");
    var navM = document.querySelector(".yb-toc-m nav");
    if (!article || (!navD && !navM)) return;

    var heads = Array.prototype.slice.call(article.querySelectorAll("h2"));
    if (!heads.length) return;

    var used = {};
    var items = heads.map(function (h) {
      var id = h.id || slugify(h.textContent);
      while (used[id]) id += "-2";
      used[id] = true;
      h.id = id;
      h.style.scrollMarginTop = "92px";
      return { id: id, text: h.textContent.trim(), el: h };
    });

    items.forEach(function (it, i) {
      if (navD) {
        var a = document.createElement("a");
        a.href = "#" + it.id;
        a.textContent = it.text;
        a.setAttribute("data-toc", it.id);
        navD.appendChild(a);
      }
      if (navM) {
        var b = document.createElement("a");
        b.href = "#" + it.id;
        b.textContent = (i + 1) + " · " + it.text;
        navM.appendChild(b);
      }
    });

    var tocM = document.querySelector(".yb-toc-m");
    if (tocM && navM) {
      navM.addEventListener("click", function () { tocM.removeAttribute("open"); });
    }

    var links = Array.prototype.slice.call(document.querySelectorAll("[data-toc]"));
    if (links.length && "IntersectionObserver" in window) {
      var setActive = function (id) {
        links.forEach(function (l) {
          l.classList.toggle("is-active", l.getAttribute("data-toc") === id);
        });
      };
      var io = new IntersectionObserver(function (ents) {
        var vis = ents.filter(function (e) { return e.isIntersecting; })
          .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
        if (vis.length) setActive(vis[0].target.id);
      }, { rootMargin: "-90px 0px -65% 0px", threshold: 0 });
      items.forEach(function (it) { io.observe(it.el); });
    }
  }

  /* ---- 2. BARRE DE PROGRESSION ---- */
  function progressBar() {
    var bar = document.querySelector(".yb-progress__bar");
    if (!bar) return;
    var onScroll = function () {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      var st = window.pageYOffset || h.scrollTop || 0;
      bar.style.width = (Math.min(1, Math.max(0, st / max)) * 100).toFixed(1) + "%";
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    onScroll();
  }

  /* ---- 4. CARTE PRODUIT AUTO ---- */
  function euro(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + "\u00A0€";
  }
  function productCards() {
    if (!article) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    if (root.charAt(root.length - 1) !== "/") root += "/";
    var CTA = { en:"Discover", fr:"Découvrir", de:"Entdecken", it:"Scopri", es:"Descubrir", uk:"Discover", nl:"Ontdekken", pt:"Descobrir" };
    var lang = (document.documentElement.lang || "fr").slice(0, 2).toLowerCase();
    var ctaLabel = CTA[lang] || CTA.fr;

    var seen = {};
    var links = article.querySelectorAll('a[href*="/products/"]');
    Array.prototype.forEach.call(links, function (a) {
      var m = a.getAttribute("href").match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1];
      var p = a.closest("p");
      if (!p || p.getAttribute("data-yb-cta") === "off") return;
      if (seen[handle]) return;
      seen[handle] = true;

      var mount = document.createElement("div");
      p.parentNode.insertBefore(mount, p.nextSibling);

      fetch(root + "products/" + handle + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          var promo = d.compare_at_price && d.compare_at_price > d.price;
          var pct = promo ? Math.round((1 - d.price / d.compare_at_price) * 100) : 0;
          var img = d.featured_image ? (d.featured_image + (d.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=520") : "";
          mount.className = "yb-product";
          mount.innerHTML =
            (img ? '<div class="yb-product__img"><img src="' + img + '" alt="' + (d.title || "") + '" loading="lazy"></div>' : "") +
            '<div><h4>' + (d.title || "") + "</h4>" +
              '<div class="yb-product__price"><b>' + euro(d.price) + "</b>" +
                (promo ? "<s>" + euro(d.compare_at_price) + "</s><em>\u2212" + pct + "%</em>" : "") +
              "</div>" +
              '<a class="yb-product__btn" href="' + root + "products/" + handle + '">' + ctaLabel + "</a>" +
            "</div>";
        })
        .catch(function () { mount.parentNode && mount.parentNode.removeChild(mount); });
    });
  }

  /* ---- 5. JSON-LD FAQPage AUTO (depuis les <details> de l'article) ---- */
  function faqSchema() {
    if (!article) return;
    var scope = article.querySelector(".yb-faq") || article;
    var qas = [];
    Array.prototype.forEach.call(scope.querySelectorAll("details"), function (d) {
      var q = d.querySelector("summary");
      if (!q) return;
      // réponse = tout le contenu du <details> sauf le <summary>
      var ans = "";
      Array.prototype.forEach.call(d.children, function (c) {
        if (c !== q) ans += c.textContent + " ";
      });
      ans = ans.replace(/\s+/g, " ").trim();
      var question = q.textContent.replace(/\s+/g, " ").trim();
      if (question && ans) {
        qas.push({
          "@type": "Question",
          name: question,
          acceptedAnswer: { "@type": "Answer", text: ans }
        });
      }
    });
    if (!qas.length) return;
    var s = document.createElement("script");
    s.type = "application/ld+json";
    s.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: qas
    });
    document.head.appendChild(s);
  }

  buildTOC();
  progressBar();
  productCards();
  faqSchema();
})();